import { useState, useEffect, useCallback } from 'react';
import { getInvoiceList, getPracticeInvoiceList, TGetPaymentBillingList, getPaymentBillingList } from 'api/provider';
import { getGPInvoiceList } from 'api/group';
import { TPaymentBilling } from 'types/provider';

const usePatientPaymentBillingList = (
    param?: Partial<TGetPaymentBillingList>,
    isPracticeView?: boolean,
    // Caller owns all fetching (e.g. PaymentTable merges filters/sort/page/time range itself)
    manual?: boolean,
): [TPaymentBilling[] | undefined, number, boolean, (param?: Partial<TGetPaymentBillingList>) => void] => {
    const [data, setData] = useState<TPaymentBilling[]>();
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);

    const fetchData = async (para: Partial<TGetPaymentBillingList> = {}) => {
        try {
            setLoading(true);
            const merged = { current: 1, size: 8, ...para };
            // Practice View: per-client billing uses the client-scoped GP endpoint; the practice-wide
            // Financials view (no clientId) uses the practice invoice list which spans all providers.
            const hasClientId = merged.clientId != null || param?.clientId != null;
            let request: (p: any) => Promise<any>;
            if (isPracticeView) {
                request = hasClientId ? getGPInvoiceList : getPracticeInvoiceList;
            } else {
                request = getInvoiceList;
            }
            const res = await request(merged);
            if (!res.error) {
                const list = res.data?.data?.records || [];
                const amount = res.data?.data?.total;
                setTotal(amount || 0);
                setData(list);
            }
        } catch (err) {
            console.error('Payment list fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (manual) {
            return;
        }
        fetchData(param);
    }, [param?.clientId, param?.timeRangeMonths]);

    return [data, total, loading, fetchData];
};

export default usePatientPaymentBillingList;
